import { BooleanDataDefinition } from "../../../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { ExpressionConfiguration } from "../../../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { RuleTableConfiguration } from "../../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { RuleTableColumn } from "../../../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableRuleColumn";
import { RuleTableRow } from "../../../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableRow";

export const bindRuleTableCellExpression = (
    config: RuleTableConfiguration,
    row: RuleTableRow,
    column: RuleTableColumn,
    expression: ExpressionConfiguration,
) => {
    row.ruleCells[column._id].expression = expression;
    normalizeRuleTableCellExpression(config, column, expression);
};

export const normalizeRuleTableCellExpression = (
    config: RuleTableConfiguration,
    column: RuleTableColumn,
    expression: ExpressionConfiguration,
) => {
    expression.inputData = () => config.getInputDefinition();
    expression.executionResult = () => new BooleanDataDefinition();
    expression.allowTrueValueResult = true;
    expression.requiredVariable = config.getRuleColumnData(column);
};

export const normalizeRuleTableCellExpressions = (config: RuleTableConfiguration) => {
    config.syncAllRows();
    config.rows.forEach((row) => {
        config.ruleColumns.forEach((column) => {
            const expression = row.ruleCells[column._id]?.expression;
            if (expression) normalizeRuleTableCellExpression(config, column, expression);
        });
    });
};
